exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tct-bi-field{display:block;width:100%}.tct-bi-field{-webkit-column-break-inside:avoid;break-inside:avoid;margin:0 5px 10px;-webkit-box-sizing:border-box;box-sizing:border-box}.tct-bi-field__key{font-weight:700;margin-bottom:5px;font-size:15px}.tct-bi-field__key span{display:block;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.tct-bi-field__value{font-size:14px}.tct-bi-field__input,.tct-bi-field__input input{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}@media print{.tct-bi-field__key{font-size:1.1em}.tct-bi-field__value{font-size:1em}}", ""]);

// exports
